// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// See: https://angular.io/guide/build

export const environment = {
  production: false,
  api_url: 'http://localhost:8080',
  // @ts-ignore
  env: process.env.NODE_ENV,
  // version: VERSION
  registrationEnabled: false,
  registrationDeactivationDate: ""
};
